import React from "react";

import styles from "./AchievementRate.module.scss";

export interface IAchievementRateProps {
  achieved: number;
  total: number;
}

const AchievementRate: React.FC<IAchievementRateProps> = ({
  achieved,
  total,
}) => {
  const size = 120;
  const strokeWidth = 4;
  const center = size / 2;
  const percentage = total > 0 ? (achieved / total) * 100 : 0;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={styles.chart}
    >
      <circle
        className={styles.backgroundCircle}
        cx={center}
        cy={center}
        r={radius}
        strokeWidth={strokeWidth}
      />
      <circle
        className={styles.progressCircle}
        cx={center}
        cy={center}
        r={radius}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
      />
      <text x="50%" y="40%" className={styles.percentageText}>
        <tspan className={styles.percentageNumber}>
          {Math.round(percentage)}
        </tspan>
        <tspan className={styles.percentageSymbol} dx="4" dy="2">
          %
        </tspan>
      </text>
      <text x="50%" y="62.5%" className={styles.label}>
        行動リスト達成率
      </text>
    </svg>
  );
};

export default AchievementRate;
